import React from 'react';

import { PropertyFacilities } from '@ha/api-v2/types/inventory/Property';
import { Building } from '@hbf/icons/brand-bold';

import { useIntl } from 'ha/i18n';
import { ListingCardModel } from 'ha/models/Listing/types';

import { PropertyFacilitiesTranslations } from 'ha/modules/PBSA';

import { normalizePropertyFacilities } from '../utilities/normalizePropertyFacilities';

import { ListingCardDetailsAttribute } from './ListingCardDetailsAttributes';

interface ListingCardDetailsAttributesPropertyFacilitiesProps {
  listing: ListingCardModel;
}

export const ListingCardDetailsAttributesPropertyFacilities = React.memo(
  ({ listing }: ListingCardDetailsAttributesPropertyFacilitiesProps) => {
    const { T } = useIntl();

    const facilities = React.useMemo(
      () => normalizePropertyFacilities(listing.property.facilities),
      [listing],
    );

    const [randomizedFacilities, setRandomizedFacilities] =
      React.useState<PropertyFacilities[]>(facilities);

    React.useEffect(() => {
      const shuffledFacilities = [...facilities].sort(
        () => Math.random() - 0.5,
      );
      setRandomizedFacilities(shuffledFacilities.slice(0, 2));
    }, [facilities]);

    const hasMoreFacilities = facilities.length > 2;

    const slice = randomizedFacilities
      .slice(0, 2)
      .map(facility => T(PropertyFacilitiesTranslations[facility]));

    const selectedFacilities = hasMoreFacilities
      ? [...slice, T('listing_card.and_more')]
      : slice;

    if (selectedFacilities.length === 0) return null;

    return (
      <ListingCardDetailsAttribute
        slots={{
          icon: Building,
          label: selectedFacilities.join(', '),
        }}
        data-test-locator="ListingCard/AttributesFacilities"
      />
    );
  },
);
